/* 🤖 this file was generated by svg-to-ts */
export const iconEth: {
  name: 'eth';
  data: string;
} = {
  name: 'eth',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none" viewBox="0 0 32 32"><g clip-path="url(#ethereum__clip0_294_3461)"><path fill="currentColor" d="M16 0C7.164 0 0 7.164 0 16s7.164 16 16 16 16-7.164 16-16S24.836 0 16 0m-.339 29.106-8.005-11.29 8.005 4.804zM8.015 16.43l7.646-3.5v7.934L8.015 16.42zm7.646-4.218-7.717 3.5L15.66 2.894zm.729-9.319 7.718 12.819-7.718-3.5zm0 10.037 7.646 3.5-7.646 4.444zm0 9.699 8.005-4.803-8.005 11.29z"/></g><defs><clipPath id="ethereum__clip0_294_3461"><path fill="#fff" d="M0 0h32v32H0z"/></clipPath></defs></svg>`,
};
